import React from 'react'
import ChooseClinic from '../../containers/landingPage/ScheduleScan/ChooseClinic';
import ChooseDentist from '../../containers/landingPage/ScheduleScan/ChooseDentist';
import useApp from '../../store/app/appContext';
import ClinicsProvider from '../../store/clinics/clinicsProvider';
import UsersProvider from '../../store/users/usersProvider';
import axios from 'axios';
import { API_BASE_URL } from '../../config';
import Steps2 from '../../components/landingPage/ScanAndGo/Steps2';
import PageWrapper from '../../containers/app/PageWrapper';
import LogoWithCaptionWhite from '../../components/Logos/LogoWithCaptionWhite';
import CopyrightCaption from '../../components/App/CopyrightCaption';
import {LOGO_SIZES} from '../../config'
import PrimaryButton from '../../components/Buttons/PrimaryButton';
import { useHistory } from 'react-router-dom';
import SuccessPopUp from '../../components/landingPage/ScanAndGo/SuccessPopUp';
import useWindowSize from '../../hooks/useWindowSize';
import QuestionnaireForm from '../../containers/landingPage/ScheduleScan/QuestionnaireForm';
import SecondaryButton from '../../components/Buttons/SecondaryButton';
import useNotification from '../../store/notification/notificationContext';
import { NOTIFICATIONS } from '../../config';

function ScheduleScanAndGo() {

  const history = useHistory();
  const {setNotification} = useNotification();
  const [selectedClinic, setSelectedClinic] = React.useState(null);
  const [selectedDentist, setSelectedDentist] = React.useState(null);
  const [pickedDentist, setPickedDentist] = React.useState(null);

  const [currentStep, setCurrentStep] = React.useState("1");

  const { appState: { user, isAuthenticated } } = useApp();

  function isCalendlyEvent(e) {
    return e.data.event && e.data.event.indexOf('calendly') === 0;
  };
  
  const handleScheduleScanAndGo = async (appointment) => {
    const data = {
      partnerId: selectedDentist.user_id._id,
      clinicId: selectedClinic.id,
      appointmentId: appointment.appointmentId,
    }
    await axios.post(`${API_BASE_URL}/treatment/create-scan-and-go`, data).then(res => {
      const response = res.data;
      setCurrentStep("5");
      return response;
    }).catch(err => {
      alert('Error scheduling Scan & Go. Please try again later, or contact our team.')
     // notification is not working, idk why. to avoid hassle, added an alert instead
      // setNotification({
      //   show: true,
      //   type: NOTIFICATIONS.TYPE.WARNING_YELLOW,
      //   title: 'Server error',
      //   message: err.response.data.message || 'Issue scheduling Scan & Go. Please try again later.'
      // });
      throw err;
    })
  }
  
  const handleConfirmDentist = () => {
    setSelectedDentist(pickedDentist)
    setCurrentStep("4");
  }

  const eventHandler = async (e) => {
    if (isCalendlyEvent(e)) {
      if (e.data.event === 'calendly.event_scheduled') {
        const eventUri = e.data.payload.event.uri;
        const lastIndex = eventUri.lastIndexOf('/');
        const eventId = eventUri.substring(lastIndex + 1, eventUri.length);
        const appointmentData = {
          appointmentId: eventId
        }
        await handleScheduleScanAndGo(appointmentData);
      }
    }
  }

  const getLocationDetails = () => {
    let address = selectedClinic.address ? selectedClinic.address + ', ' : ''
    let city = selectedClinic.city ? selectedClinic.city + ', ' : ''
    let country= selectedClinic.country ? selectedClinic.country + ', ' : ''
    let postal_code = selectedClinic.postalCode ? selectedClinic.postalCode : ''
    return `${address} ${city} ${country} ${postal_code}`

}

  const handleScheduleAppointmentClick = (dentist) => {
    window.Calendly.initPopupWidget({
      url: dentist.user_id.calendly.scheduling_url  + `?location=${getLocationDetails()}`,
      prefill: {
        name: `${user.first_name} ${user.last_name}`,
        email: `${user.email}`,
      }
      ,
    });
    return false;
  }

  React.useEffect(() => {
    window.removeEventListener('message', eventHandler);
    window.addEventListener('message', eventHandler);
    return () => {
      window.removeEventListener('message', eventHandler);
    }
  }, [selectedDentist]);

  const PAGE_STYLE = {
    backgroundColor: 'white',
    minHeight: '820px'
  }

  const captionStyle = {
    minWidth: '45%'
  }

  const cityOptions = [{
    label: "Brussels",
    value: "Brussels"
  }]

  const windowSize = useWindowSize();

  return (
    <PageWrapper style={PAGE_STYLE} className="2xl:h-screen 2xl:bg-d-shape 2xl:bg-left 2xl:py-8 2xl:px-12 2xl:bg-xauto-y100 bg-mobile bg-top py-6 lg:px-8 w-full bg-no-repeat flex flex-col">
      <div className="flex flex-row items-center justify-center xl:justify-between" onClick={() => {history.push("/patient")}}>
        <LogoWithCaptionWhite className={`cursor-pointer ${LOGO_SIZES.CAPTION.dynamic}`}/>
        <div className='w-52 hidden 2xl:block'>
          <SecondaryButton text='Back to website' onClick={() => history.push('/patient')}/>
        </div>
      </div>
      <div className="flex-grow flex items-center 2xl:flex-row flex-col py-8 2xl:py-0">
          <div className='flex flex-col min-h-170 2xl:min-h-0 px-8 lg:px-0' style={captionStyle}>
            <span className='text-white md:text-4xl text-xl'>Book a Scan & Go consultation</span>
            {isAuthenticated? 
            <span className='text-white mt-2'>Select a clinic from the map, select a dentist associated with that clinic and then check dentist's schedule to book your appointment.</span>
            :
            <span className='text-white mt-2'>Log in or sign up in before scheduling an appointment</span>
            }
          </div>
        <div className='w-full h-full px-2 lg:px-0 flex flex-col 2xl:justify-between mt-0 lg:mt-6 xl:mt-0 2xl:mr-0 xl:justify-between justify-between max-h-max xl:min-w-0'>
          <Steps2 selectedClinic={selectedClinic} selectedDentist={selectedDentist} setSelectedClinic={setSelectedClinic} setSelectedDentist={setSelectedDentist} setPickedDentist={setPickedDentist} currentStep={currentStep} setCurrentStep={setCurrentStep}/>
          {currentStep === "1" &&
          <UsersProvider>
            <QuestionnaireForm setCurrentStep={setCurrentStep}/>
          </UsersProvider>
          }
          {currentStep === "2" && 
          <ClinicsProvider>
            <ChooseClinic selectedClinic={selectedClinic} setSelectedClinic={setSelectedClinic} setCurrentStep={setCurrentStep}/>
          </ClinicsProvider>
          }
          {currentStep === "3" &&
          <UsersProvider>
            <ChooseDentist selectedClinic={selectedClinic} selectedDentist={selectedDentist} setCurrentStep={setCurrentStep} handleConfirmDentist={handleConfirmDentist} setPickedDentist={setPickedDentist} pickedDentist={pickedDentist}/>
          </UsersProvider>
          }							
          {currentStep === "4" && 
          <div className="flex flex-col h-full lg:gap-20 justify-between" style={{ height: windowSize.width > windowSize.tailwind.md ? '580px' : '342px' }}>
            <div className=" ml-8 lgpy-4 lg:py-16:ml-20">
              <div>
                <h1 className="font-medium text-lg mb-6">Summary</h1>
              </div>
              <div className="flex flex-col justify-around">
                <div className="py-4 w-80 h-30 p-2">
                  <h2 className="text-lg text-primary pb-4">Clinic</h2>
                  <div className="max-w-max flex flex-col gap-2">
                    <p>Name: {selectedClinic.name}</p>
                    <p>Address: {selectedClinic.address}, {selectedClinic.postalCode}, {selectedClinic.city}</p>
                  </div>
                </div>
                <div className="py-4 w-80 h-30 p-2">
                  <h2 className="text-lg text-primary pb-4">Dentist</h2>
                  <div className="max-w-max flex flex-col gap-2">
                    <p>Name: {selectedDentist?.user_id.first_name} {selectedDentist?.user_id.last_name}</p>
                    <p>Email: {selectedDentist?.user_id.email}</p>
                    <p>Phone Number: {selectedDentist?.user_id.mobile_nb}</p>
                  </div>
                </div>
              </div>
            </div>
            <PrimaryButton text="View scheduling options" className="" onClick={() => {handleScheduleAppointmentClick(selectedDentist)}}/>
          </div>
          }
          {currentStep === "5" &&
          <div className="w-full h-full flex justify-center">
            <SuccessPopUp />
          </div>
          }
        </div>
        {currentStep !== "5" &&
         <div className='mt-4 w-full 2xl:hidden block'>
          <SecondaryButton large text='Back to website' onClick={() => history.push('/patient')}/>
        </div>
        }
      </div>
      <div className='flex justify-center xl:justify-end xl:mt-8'>
        <CopyrightCaption/>
      </div>
    </PageWrapper>

        
  )
}

export default ScheduleScanAndGo
